import axios from 'axios';

const global = axios.create({
    baseURL: process.env.REACT_APP_GLOBAL,
});

export default global;
